import { CategoryFormData } from "../types/categoryTypes";

export const DefaultCategoryFormValues: CategoryFormData = {
  name: "",
  description: "",
  parentId: undefined
};
